// --- NEW FILE: packages/components/src/quotes/QuoteActionBar.tsx ---

import React from 'react';
import { Button } from '@dopomogai/ui';
import { Download, Share2, Edit, CreditCard } from 'lucide-react';

type QuoteStatus = 'pending' | 'paid' | 'expired';

type Props = {
  status: QuoteStatus;
  isPaying: boolean;
  onPay: () => void;
  onShare: () => void;
  onDownload: () => void;
  onEdit: () => void;
};

export function QuoteActionBar({ status, isPaying, onPay, onShare, onDownload, onEdit }: Props) {
  return (
    <div className="mb-6 flex flex-wrap items-center gap-2 print:hidden">
      {status === 'pending' && (
        <Button onClick={onPay} disabled={isPaying} icon={<CreditCard size={16} />}>
          {isPaying ? 'Processing...' : 'Pay Now'}
        </Button>
      )}

      {status === 'expired' && (
        <Button onClick={onEdit} icon={<Edit size={16} />}>
          Create New Quote
        </Button>
      )}

      <Button variant="secondary" onClick={onShare} icon={<Share2 size={16} />}>
        Share
      </Button>
      <Button variant="outline" onClick={onDownload} icon={<Download size={16} />}>
        Save as PDF
      </Button>
      
      {/* Show edit button for pending quotes so users can go back and tweak */}
      {status === 'pending' && (
        <Button variant="ghost" onClick={onEdit}>
          Edit Configuration
        </Button>
      )}
    </div>
  );
}